"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var a=Math.ceil,e=Math.floor,n=Math.trunc||function(t){var r=+t;return(r>0?e:a)(r)};exports.mathTrunc=n;
